// extracted by mini-css-extract-plugin
export default {"h2":"Agenda_h2__o3WJA","table":"Agenda_table__mSXzj","link":"Agenda_link__pr09i","td":"Agenda_td__R-APm","content":"Agenda_content__vumjm"};